// file: src/KalkulatorRadniStaz.js

import React, { useState } from 'react';
import './Kalkulator.css';
import { FaCalendarAlt } from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { bs } from 'date-fns/locale';


// Helper za dohvat današnjeg datuma u "YYYY-MM-DD" formatu
function todayDateString() {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

function KalkulatorRadniStaz() {
  const [ranijiGodine, setRanijiGodine] = useState(0);
  const [ranijiMjeseci, setRanijiMjeseci] = useState(0);
  const [ranijiDani, setRanijiDani] = useState(0);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [koristiTrenutni, setKoristiTrenutni] = useState(false);

  const [rezultat, setRezultat] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);

  const handleCheckbox = (e) => {
    setKoristiTrenutni(e.target.checked);
    if (e.target.checked) {
      setEndDate(new Date());
    } else {
      setEndDate(null);
    }
  };

  const handleIzracunaj = async () => {
    setErrorMsg(null);
    setRezultat(null);

    // --- validacija ---
    if (!startDate) {
      setErrorMsg('Molimo unesite datum početka zaposlenja.');
      return;
    }
    if (!koristiTrenutni && !endDate) {
      setErrorMsg('Molimo unesite datum završetka zaposlenja ili čekirajte “trenutno radim”.');
      return;
    }
    
    // [Inference] Validacija za raniji staž - Mjeseci
    if (ranijiMjeseci > 11) {
      setErrorMsg('Broj mjeseci u raniji radni staž ne može biti veći od 11. Molimo, pretvorite 12 mjeseci u dodatnu 1 godinu.');
      return;
    }

    // [Inference] Validacija za raniji staž - Dani
    if (ranijiDani > 30) {
      setErrorMsg('Broj dana u raniji radni staž ne može biti veći od 30. Molimo, pretvorite 31 dan u dodatni 1 mjesec.');
      return;
    }
    
    // format JSON
    const payload = {
      raniji_godine: ranijiGodine,
      raniji_mjeseci: ranijiMjeseci,
      raniji_dani: ranijiDani,
      start_date: startDate.toISOString().split('T')[0],
      end_date: (koristiTrenutni ? new Date() : endDate)
        .toISOString()
        .split('T')[0],
    };

    try {
      const res = await fetch('https://plata--kalkulator-backend-api--gklzkvjpw2s5.code.run/radni-staz/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || 'Greška pri izračunu.');
      }
      const data = await res.json();
      setRezultat(data);
    } catch (err) {
      setErrorMsg(err.message);
    }
  };

  return (
    <div className="container">
      {/* ----- UNOSNI DIO ----- */}
      <div className="form-container card">
        <div className="form-header">
          <h2>
            Kalkulator radnog staža <FaCalendarAlt />
          </h2>
        </div>

        {/* Raniji staž */}
        <div className="field-group">
          <label className="field-label">
            Raniji radni staž:
          </label>
          <div style={{ display: 'flex', gap: '8px' }}>
            <div>
              <input
                type="number"
                min="0"
                className="field-input"
                value={ranijiGodine}
                // Dozvoljavamo unos dok kuca, ali pazimo na NaN
                onChange={(e) => {
                  const val = e.target.value;
                  setRanijiGodine(val === '' ? '' : parseInt(val, 10));
                }}
                // [Inference] Kada korisnik klikne van polja, ako je prazno, stavi 0
                onBlur={(e) => {
                  if (e.target.value === '' || e.target.value === 'NaN') {
                    setRanijiGodine(0);
                  }
                }}
                placeholder="godine"
              />
              <small>god.</small>
            </div>
            <div>
              <input
                type="number"
                min="0"
                max="11"
                className="field-input"
                value={ranijiMjeseci}
                // Dozvoljavamo unos dok kuca, ali pazimo na NaN
                onChange={(e) => {
                  const val = e.target.value;
                  setRanijiMjeseci(val === '' ? '' : parseInt(val, 10));
                }}
                // [Inference] Kada korisnik klikne van polja, ako je prazno, stavi 0
                onBlur={(e) => {
                  if (e.target.value === '' || e.target.value === 'NaN') {
                    setRanijiMjeseci(0);
                  }
                }}
                placeholder="mjeseci"
              />
              <small>mj.</small>
            </div>
            <div>
              <input
                type="number"
                min="0"
                max="30"
                className="field-input"
                value={ranijiDani}
                // Dozvoljavamo unos dok kuca, ali pazimo na NaN
                onChange={(e) => {
                  const val = e.target.value;
                  setRanijiDani(val === '' ? '' : parseInt(val, 10));
                }}
                // [Inference] Kada korisnik klikne van polja, ako je prazno, stavi 0
                onBlur={(e) => {
                  if (e.target.value === '' || e.target.value === 'NaN') {
                    setRanijiDani(0);
                  }
                }}
                placeholder="dani"
              />
              <small>dn.</small>
            </div>
          </div>
        </div>

        {/* Datum početka */}
        <div className="field-group">
          <label htmlFor="startDate" className="field-label">
            Datum početka zaposlenja<span className="required">*</span>:
          </label>
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            dateFormat="dd.MM.yyyy"
            locale={bs}
            placeholderText="dd.mm.gggg"
            className="field-input"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            yearDropdownItemNumber={70}
            scrollableYearDropdown
            maxDate={new Date()}
          />
        </div>

        {/* Datum završetka ili trenutno */}
        <div className="field-group">
          <label htmlFor="endDate" className="field-label">
            Datum završetka zaposlenja<span className="required">*</span>:
          </label>
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            dateFormat="dd.MM.yyyy"
            locale={bs}
            placeholderText="dd.mm.gggg"
            className="field-input"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            yearDropdownItemNumber={70}
            scrollableYearDropdow
            maxDate={new Date()}
            id="endDate"
            disabled={koristiTrenutni}
          />
          <label style={{ marginLeft: '8px', display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              checked={koristiTrenutni}
              onChange={handleCheckbox}
            />
            <span style={{ marginLeft: '4px' }}>Trenutno radim</span>
          </label>
        </div>

        {/* Gumb “Izračunaj” */}
        <div style={{ marginTop: '16px' }}>
          <button className="field-input" onClick={handleIzracunaj}>
            Izračunaj
          </button>
        </div>

        {errorMsg && (
          <div className="error-text" style={{ marginTop: '12px' }}>
            {errorMsg}
          </div>
        )}
      </div>

      {/* ----- REZULTATI ----- */}
      <div className="results-container card" style={{ marginTop: '20px' }}>
        {rezultat && (
          <>
            <h3 className="section-title">Rezultati</h3>
            <div className="results-section">
              <div className="result-row">
                <span>Ukupan radni staž:</span>
                <span>
                  {rezultat.ukupno_godine} god. {rezultat.ukupno_mjeseci} mj. {rezultat.ukupno_dani} dn.
                </span>
              </div>
              <div className="result-row">
                <span>Preostalo do sljedeće pune godine staža:</span>
                <span>
                  {rezultat.preostalo_mjeseci} mj. {rezultat.preostalo_dani} dn.
                </span>
              </div>
              <div className="result-row">
                <span>Datum sljedeće pune godine staža (od današnjeg dana):</span>
                <span>
                  {new Date(rezultat.next_anniversary)
                    .toLocaleDateString('sr-RS')}
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default KalkulatorRadniStaz; // Ili preimenujte po želji
